import { Component, OnInit } from '@angular/core';
import { ProductLiftChartR10Component } from '../../../widget-library/widgets/product-lift-chart-r10/product-lift-chart-r10.component';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
@Component({
	selector: 'app-lift-chart-r10-reskin',
	templateUrl: './lift-chart-r10-reskin.component.html',
	styleUrls: ['./lift-chart-r10-reskin.component.css']
})
export class LiftChartR10ReskinComponent extends ProductLiftChartR10Component implements OnInit {
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	ngOnInit(): void {
		super.ngOnInit();
	}

	processResponseData(): void {
		if (this.campaignsList) {
			for (const campaign of this.campaignsList) {
				if (campaign.data) {
					for (const campaignData of campaign.data) {
						if (campaignData.average_lift > 99) {
							campaignData.average_lift = 99.1;
						}
					}
				}
			}
			this.graphData = this.campaignsList[0].data;
			this.drawGraph();
		}
	}

	drawGraph() {
		this.avg_lift_max = 0;
		if (this.graphData) {
			for (const campaign of this.graphData) {
				if (campaign.average_lift > this.avg_lift_max) {
					this.avg_lift_max = campaign.average_lift;
				}
			}
		}
		this.primaryColor = this.getColorFromColorConfiguration(this.colorsconfig[0]);
		this.secondaryColor = this.getColorFromColorConfiguration(this.colorsconfig[1]);
		this.tertiaryColor = this.getColorFromColorConfiguration(this.colorsconfig[2]);
		this.baseConfig.chartConfig.toolTip.borderColor = this.primaryColor;
		this.baseConfig.chartConfig.toolTip.formatter = this.getToolTipFormatter();

		if (this.baseConfig && this.baseConfig.chartConfig && this.baseConfig.chartConfig.yAxis[0]) {
			this.baseConfig.chartConfig.yAxis[0].ceiling = this.avg_lift_max;
			this.baseConfig.chartConfig.yAxis[0].tickAmount = undefined;
		}

		if (this.baseConfig.chartConfig.series[0]) {
			this.baseConfig.chartConfig.series[0].dataLabels.format = null;
			this.baseConfig.chartConfig.series[0].dataLabels.formatter = this.getColumnLabelFormat();
		}

		this.chartConfig = {
			chartConfig: this.baseConfig.chartConfig,
			responseConfig: this.uikitresponseconfig
		};
	}
	getToolTipFormatter(): any {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		return function (): string {
			return `
			<div style='width: 8.5rem; padding: 3px;  >
				<div style='width: 100%;'>
				<div style='width: 46%; display:inline-block; text-transform: capitalize;'>${this.x.replace('<br>', ' ')}</div>
				<div style='width: 100%;'>
					<div style='width: 46%; display:inline-block; text-transform: capitalize; color: ${self.primaryColor}'>exposed</div>
					<div style='width: 46%; display:inline-block; text-align: right'>${
						this.point.average_conversion_rate < 0.01
							? '<0.01'
							: this.point.average_conversion_rate > 99
							? '>99'
							: this.point.average_conversion_rate
					}%</div>
				</div>
				<div style='width: 100%;'>
					<div style='width: 46%; display:inline-block; text-transform: capitalize; color: ${self.secondaryColor}'>lift</div>
					<div style='width: 46%; display:inline-block; text-align: right'>${
						this.y >= 1 && this.y <= 99
							? Math.round(this.y) + 'x'
							: this.y > 99
							? '>99x'
							: this.y >= 0.01 && this.y < 1
							? this.y.toFixed(2) + 'x'
							: '<0.01x'
					}</div>
				</div>
				<div style='width: 100%;'>
					<div style='width: 46%; display:inline-block; text-transform: capitalize; color: ${self.tertiaryColor}'>baseline</div>
					<div style='width: 46%; display:inline-block; text-align: right'>${
						this.point.average_baseline < 0.01
							? '<0.01'
							: this.point.average_baseline > 99
							? '>99'
							: this.point.average_baseline
					}%</div>
				</div>
			</div>`;
		};
	}

	getColumnLabelFormat(): any {
		const self = this;
		return function (): any {
			return this.y >= 1 && this.y <= 99
				? Math.round(this.y) + 'x'
				: this.y > 99
				? '>99x'
				: this.y >= 0.01 && this.y < 1
				? this.y.toFixed(2) + 'x'
				: '<0.01x';
		};
	}
}
